import { render, staticRenderFns } from "./TrialTimer.vue?vue&type=template&id=229288f4"
import script from "./TrialTimer.vue?vue&type=script&lang=js"
export * from "./TrialTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports